<template>
    <div>
        <a :href="getUrl(premisePage.alias.url)">
            <div class="catalog-item-name">
                <p :title="premisePage.name">{{premisePage.name}}</p>
            </div>
            <div class="top-row">
              <div class="status-block">
                <div class="status" :class="'status-' + statusItem.id" v-for="statusItem in premisePage.statuses">
                  {{statusItem.name}}
                </div>
              </div>

                <div class="item-image">
                    <img class="b-lazy img-fluid"
                         :src="premisePage.image.src"
                         :alt="premisePage.image.alt">
                </div>
                <div class="text-block">
                    <div class="premise-address">
                        <p>{{premisePage.address}}</p>
                    </div>
                    <div class="premise-text text-section d-none d-sm-block">
                        <p class="cut-text" v-html="cutText"></p>
                    </div>
                </div>
            </div>
        </a>
        <div class="bottom-row d-flex">
            <div class="price-block">
                <p><span>{{ Lang.get('js.my-warehouse.price') }}</span>{{premisePage.price}} {{premisePage.measure}}</p>
            </div>
            <div class="area-block">
                <p><span>{{ Lang.get('js.my-warehouse.square') }}</span>{{premisePage.area}}м2</p>
            </div>
        </div>
        <div class="button-call" @click="addPremiseData">
            <span class="btn-callback my-btn type-2">{{ Lang.get('js.order_button') }}</span>
        </div>
    </div>
</template>

<script>

    export default {
        name: "premise-page-preview",
        props: {
            premisePage: {
                required: true,
                // type: Object,
            },
        },
        data() {
            return {
                defaultLanguage,
                imageSrc: '/images/default/preload.gif',
                lang: window.Lang,
                Lang,
            }
        },

        computed: {
            cutText() {
                let text = this.premisePage.text;
                let limit = 75;

                text = text.trim();
                if (text.length <= limit) {
                    return text;
                }
                text = text.slice(0, limit);

                return text.trim().replace(/<[^>]+>/g, '') + " <span class=\"button-next\">дальше...</span>";

            },
        },

        methods: {

            getUrl(link) {
                return window.location.origin + '/' + link;
            },
            addPremiseData() {
                localStorage.clear();
             // localStorage.setItem('premiseId', this.premisePage.id);
             localStorage.setItem('premiseName', this.premisePage.name);
             localStorage.setItem('premiseType', this.premisePage.premise_type);
                console.log(localStorage);
            }
        },

        mounted() {
            if (!this.premisePage.alias) {
                console.log(this.premisePage.id);
            }


        }
    }
</script>



// WEBPACK FOOTER //
// resources/js/components/premise/PremisePagePreview.vue